import useWidth from '@/hooks/useWidth'
import {
  Button,
  Col,
  FieldInput,
  Form,
  Label,
  notification,
  PrevLogo,
  Radio,
  Row,
  Typography,
  useErrorHandlingContext,
  usePrevTheme,
} from '@prev/ui-kit'
import React, { useContext, useEffect, useState } from 'react'
import ForgotOfficeModal from '../forgotOffice/ForgotOfficeModal'
import { LoginContext } from '../../contexts/LoginContext'
import { useNavigate } from 'react-router-dom'

const { Text } = Typography

interface FormRules {
  office: string
}

const SlugSignIn = (): JSX.Element => {
  const { handleOffice, setCheckedSlug } = useContext(LoginContext)
  const { theme } = usePrevTheme()
  const [forgotOfficeModal, setForgotOfficeModal] = useState(false)
  const [form] = Form.useForm<FormRules>()
  const [isLoading, setIsLoading] = useState(false)
  const [storedSlugs] = useState(JSON.parse(localStorage.getItem('storedSlugs') ?? '[]'))
  const [selectedSlug, setSelectedSlug] = useState<string>(storedSlugs[0])
  const width = useWidth()
  const { setGlobalError } = useErrorHandlingContext()
  const navigate = useNavigate()

  useEffect(() => {
    setCheckedSlug(false)
    if (storedSlugs) {
      form.setFieldValue('office', storedSlugs[0])
    }
  }, [storedSlugs])

  useEffect(() => {
    form.setFieldValue('office', selectedSlug)
  }, [selectedSlug])

  return (
    <Col
      span={10}
      xxl={10}
      xl={10}
      lg={10}
      md={10}
      sm={24}
      xs={24}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Form
        data-testid="form-slug"
        name="officeForm"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: `0 ${width < 1280 ? '20px' : '95px'}`,
        }}
        onFinish={async (form) => {
          try {
            setIsLoading(true)
            await handleOffice(form.office)
            setCheckedSlug(true)
          } catch (err) {
            setGlobalError(err)
            setIsLoading(false)
          }
        }}
        layout="vertical"
        form={form}
      >
        <Row style={{ marginBottom: '28px' }}>
          <PrevLogo />
        </Row>
        <Text emphasis style={{ fontSize: '24px', marginBottom: '17px' }}>
          Log in
        </Text>
        {storedSlugs.length > 0 && (
          <Form.Item name="office" style={{ margin: 0, padding: 0 }} initialValue={selectedSlug}>
            <Radio.Group name="office">
              <Row style={{ flexDirection: 'column', gap: '10px' }}>
                {storedSlugs.map((e, index) => (
                  <Radio
                    disabled={isLoading}
                    data-testid="radio-stored-slugs"
                    key={e}
                    value={e}
                    onChange={() => setSelectedSlug(e)}
                    defaultChecked={index === 0}
                  >
                    {e}
                  </Radio>
                ))}
                <Radio disabled={isLoading} data-testid="radio-slug-outro" value="" onChange={() => setSelectedSlug('')}>
                  Outro
                </Radio>
              </Row>
            </Radio.Group>
          </Form.Item>
        )}
        {!selectedSlug && (
          <>
            <Label style={{ marginTop: '8px' }}>
              Link do escritório <span style={{ color: theme.color.text.danger }}>*</span>
              <Form.Item
                name="office"
                style={{ margin: 0 }}
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório',
                  },
                ]}
              >
                <Row align="middle" style={{ gap: '9px' }}>
                  <Col>
                    <FieldInput
                      disabled={isLoading}
                      style={{ width: '260px' }}
                      data-testid="inpt-nome-escritorio"
                      placeholder="Ex: nomedoescritorio"
                    />
                  </Col>
                  <Col>
                    <Text emphasis>.prev.app</Text>
                  </Col>
                </Row>
              </Form.Item>
            </Label>
          </>
        )}
        <Row>
          <Button
            onClick={() => {
              setForgotOfficeModal(true)
            }}
            style={{ cursor: 'pointer', padding: 0 }}
            data-testid="link-esqueceu-escritorio"
            type="link"
            disabled={isLoading}
          >
            Esqueceu o escritório?
          </Button>
        </Row>
        <Button
          size="large"
          data-testid="btn-avancar-login"
          htmlType="submit"
          type="primary"
          style={{ marginTop: '40px', width: '340px' }}
          loading={isLoading}
        >
          <Text color="white" style={{ fontSize: '20px' }}>
            Avançar
          </Text>
        </Button>
        <Button
          data-testid="btn-login-sem-escritorio"
          onClick={() => navigate('/login')}
          type="link"
          style={{ width: '340px', margin: '16px 0' }}
          loading={isLoading}
        >
          Fazer login sem escritório
        </Button>
        <Row style={{ gap: '5px', alignItems: 'center' }}>
          <Text style={{ fontSize: '16px' }}>Ainda não tem conta?</Text>
          <Button type="link" data-testid="link-planos-prev" style={{ cursor: 'pointer', paddingLeft: 0 }}>
            <a
              href="https://previdenciarista.com/assine/"
              target="_blank"
              rel="noreferrer"
              style={{ color: theme.color.text.brand }}
            >
              Conheça nossos planos
            </a>
          </Button>
        </Row>
      </Form>
      <ForgotOfficeModal visible={forgotOfficeModal} handleOfficeModal={setForgotOfficeModal} />
    </Col>
  )
}

export default SlugSignIn
